import React from 'react';
import CheckOutBanner from '../../components/CheckOut/CheckOutBanner/CheckOutBanner';
import CheckOutForm from '../../components/CheckOut/CheckOutForm/CheckOutForm';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import SubHeader from '../../components/Common/SubHeader/SubHeader';

const CheckOut = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <CheckOutBanner/>
            <CheckOutForm/>
            <Footer/>
        </div>
    );
};

export default CheckOut;